import React from 'react';
import './map-button.css';
import { useDisplayPreferences } from '../displayPreferences-context';
const DataLayerSwitcher = (props) => {
    const { showLayerSelection, showOverlayList, resetLayersAndHideTheirList, darkLightTheme } = useDisplayPreferences();
    const handleSubmit = (evt) => {
        evt.preventDefault();
        if (showLayerSelection === 'enabled') {
            resetLayersAndHideTheirList(evt);
        }
        else {
            showOverlayList(evt);
        }
    };
    return (React.createElement("form", { className: `map-button ${darkLightTheme}`, onSubmit: handleSubmit },
        React.createElement("button", { className: "btn btn-outline btn-outline-dark", type: "submit" }, (showLayerSelection === 'enabled') ? 'Clear layer options' : 'Show layer options')));
};
export default DataLayerSwitcher;
